export default "__VITE_ASSET__CCLlAgGf__"